// extracted by mini-css-extract-plugin
export default {"uikit-actions-block":"uikit-actions-block__+ZMyx","uikit-actions-block__item":"uikit-actions-block__item__1j1ET"};